<div *ngIf="formattedAddress" class="bottom-arrow">
  <div class="bottom-arrow-border"></div>
  <ion-item lines="none">
    <ion-label class="ion-text-wrap">
      <h2 *ngFor="let detail of formattedAddress">{{ detail }}</h2>
    </ion-label>
  </ion-item>
</div>
